// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper_jHsCd","map":"About_map_dbrdX"};